import { Record, Static, String } from "runtypes";

export const Customer = Record({
  name: String.withConstraint((_) => _.length > 0)
});

export type Customer = Static<typeof Customer>;
